// extracted by mini-css-extract-plugin
export default {"roundSelect":"BeCashStyles_roundSelect__QFH0G"};